import React from "react";

import { StyledSVG } from "../StyledIcon";

export const ImageIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 48 48"
      fill="none"
      {...props}
    >
      <path
        d="M4 7C4 5.34315 5.34315 4 7 4H41C42.6569 4 44 5.34315 44 7V34V41C44 42.6569 42.6569 44 41 44H7C5.34315 44 4 42.6569 4 41V32V7Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 43.7798L34.8224 26L43.8225 34.0727"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 31.6267L18.32 23L4 35.7617"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="33.5"
        cy="15.5"
        r="4.5"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
